// angular
// 	.module("HeroPRO")
// 	.controller("HeroProgramController", heroProgramController);

/* @ngInject */
export default function HeroProgramController($scope) {
    const vm = this;
    vm.showHeroProgramPt1 = true;
    vm.showHeroProgramPt2 = false;

    vm.prev = () => {
        if (vm.showHeroProgramPt1) {
            $scope.training.prev();
        } else {
            vm.showHeroProgramPt1 = true;
            vm.showHeroProgramPt2 = !vm.showHeroProgramPt2;
            $scope.training.scrollToTop();
        }
    };

    vm.next = () => {
        if (vm.showHeroProgramPt2) {
            $scope.training.next();
        } else {
            vm.showHeroProgramPt2 = true;
            vm.showHeroProgramPt1 = !vm.showHeroProgramPt2;
            $scope.training.scrollToTop();
        }
    };

    vm.init = () => {
        if ($scope.training.prevTopic.TemplateName === $scope.training.currentTopic.next) {
            vm.showHeroProgramPt1 = false;
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/training/heroProgram/heroProgramController.js